module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrow pointer",
    attrs: {
      "data-direction": "direction",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(_vm.amount)
      }
    }
  }, [_c('span', {
    class: ['ico-arrow-' + _vm.direction]
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2d7f986e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7f986e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Arrow.vue
// module id = 2625
// module chunks = 0